var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Layout', [_c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Button', {
    on: {
      "click": function click($event) {
        _vm.showAddModal = true;
      }
    }
  }, [_vm._v("新增")])], 1), _c('Table', {
    ref: "grid",
    staticClass: "table-impower",
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.data,
      "loading": _vm.pageLoading
    },
    on: {
      "on-sort-change": _vm.onSortChange,
      "on-selection-change": _vm.onSelectionChange,
      "on-row-click": _vm.onRowClick
    },
    scopedSlots: _vm._u([{
      key: "download",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_c('a', {
          attrs: {
            "href": '/pmv5/service/activation/download/?product_id=' + row.no,
            "target": "_blank"
          }
        }, [_vm._v("下载")])];
      }
    }])
  }), _c('div', {
    staticClass: "grid-toolbar"
  }, [_c('Page', {
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.total,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.onCurrentPageChange
    }
  }), _c('RadioGroup', {
    staticClass: "page-selector",
    attrs: {
      "type": "button"
    },
    model: {
      value: _vm.pageSize,
      callback: function callback($$v) {
        _vm.pageSize = $$v;
      },
      expression: "pageSize"
    }
  }, _vm._l([10, 25, 50, 100], function (num) {
    return _c('Radio', {
      key: num,
      attrs: {
        "label": num
      }
    }, [_vm._v(_vm._s(num))]);
  }), 1)], 1), _c('SNSModal', {
    attrs: {
      "title": "新增授权"
    },
    on: {
      "close": _vm.onModalClose
    },
    model: {
      value: _vm.showAddModal,
      callback: function callback($$v) {
        _vm.showAddModal = $$v;
      },
      expression: "showAddModal"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };